const initialState = {    
    devices: null,
    businesssPremises: null
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {

    case "CLIENT_MAP_DEVICES":
      return{
        ...state,
        devices: action.data.data
      }
        
    case "CLIENT_MAP_BUSSINES_PREMISES":
      return{
        ...state,
        businesssPremises: action.data.data
      }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
